import styled from "styled-components";

export const StatePopupErrorMessageBox = styled.div`
  color: ${({theme}) => theme.colors.danger};
  margin: 0.5rem auto 0;
  font-size: 1.6rem;
  font-weight: 700;
`;
